import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UnassignRespondentFromSpocRPC } from "./unassignRespondentFromSpocRPC";

export class UnassignRespondentFromSpocRPCClientImpl extends UnassignRespondentFromSpocRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UnassignRespondentFromSpocRPC.Request): Promise<LeoRPCResult<UnassignRespondentFromSpocRPC.Response, UnassignRespondentFromSpocRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/UnassignRespondentFromSpoc",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UnassignRespondentFromSpocRPC.ResponseDTO,
      UnassignRespondentFromSpocRPC.Errors.ErrorsDTO,
      UnassignRespondentFromSpocRPC.Response,
      UnassignRespondentFromSpocRPC.Errors.Errors
    >(
      response,
      "spoc-management/UnassignRespondentFromSpoc",
      UnassignRespondentFromSpocRPC.Response.fromDTO,
      UnassignRespondentFromSpocRPC.Errors.fromDTO
    );
  }
}
